import { AxiosError } from 'axios';
import { useMutation, UseMutationResult } from 'react-query';
import { api } from '../api';
import queryClient from '../query-client';
import { SubscriptionDuration, SubscriptionTier } from '../types/firm';

export type UpdateSubscriptionRequest = {
    quantity?: number;
    tier?: SubscriptionTier;
    duration?: SubscriptionDuration;
};

async function updateFirmSubscription(request: UpdateSubscriptionRequest, firmId: string): Promise<void> {
    const { data } = await api.patch(`/firms/${firmId}/subscription`, request);
    return data;
}

export function useUpdateSubscription(firmId: string): UseMutationResult<void, AxiosError, UpdateSubscriptionRequest, unknown> {
    return useMutation((req) => updateFirmSubscription(req, firmId), {
        onSettled: () => {
            queryClient.invalidateQueries(['firm', firmId]);
            queryClient.invalidateQueries(['firm', firmId, 'subscription']);
        },
    });
}
